// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/climb-descent-entry.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/climb-descent-entry/climb-descent-entry.js';

mount([g0]);
